import { CommitmentData } from '../../types';
import { Column, Row } from 'further-ui/components/Layout';
import DataPoint from './DataPoint';
import { numberToCurrencyString, downloadFileFromTrpc } from 'further-ui/utils';
import Button from '@mui/material/Button';
import api from 'lib/trpcClient';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import { useNotification } from 'hooks/ui/useNotification';

type Props = Pick<
  CommitmentData,
  'vehicleId' | 'currencySettings' | 'preferredReturnBalance'
> & { commitmentIds: Array<string> };

const PreferredReturnBalance: React.FC<Props> = ({
  commitmentIds,
  vehicleId,
  currencySettings,
  preferredReturnBalance,
}) => {
  const { error } = useNotification();
  const { mutateAsync: handleDownload } =
    api.commitments.downloadReturnBalanceCalculationSheet.useMutation(
      useHandleTrpcMutation()({}),
    );
  const { currencyLcy } = currencySettings;
  const {
    outstandingPreferredReturnLcy,
    accruedPreferredReturnLcy,
    paidPreferredReturnLcy,
  } = preferredReturnBalance;

  return (
    <Column spacing="md">
      <Row centered fullWidth>
        <DataPoint
          label="Outstanding preferred return"
          value={numberToCurrencyString(outstandingPreferredReturnLcy, {
            currency: currencyLcy,
          })}
        />
        <DataPoint
          label="Accrued preferred return"
          value={numberToCurrencyString(accruedPreferredReturnLcy, {
            currency: currencyLcy,
          })}
        />
        <DataPoint
          isRowEnd
          label="Paid preferred return"
          value={numberToCurrencyString(paidPreferredReturnLcy, {
            currency: currencyLcy,
          })}
        />
      </Row>
      <Row justify="flex-end">
        <Button
          onClick={async () => {
            const data = await handleDownload({
              commitmentId: commitmentIds,
              vehicleId,
            });
            downloadFileFromTrpc(data, () => error('No documents available.'));
          }}
          variant="contained"
          size="large"
        >
          Download calculation sheet
        </Button>
      </Row>
    </Column>
  );
};

export default PreferredReturnBalance;
